import React from 'react';
import PropTypes from 'prop-types';

import V3DealTermsItem from './V3DealTermsItem';

// Section: icon + title + X/Y count chip, followed by a list of items joined
// by hairlines. The card chrome is shared across items so the section
// looks like one continuous list.
const V3DealTermsSection = ({ section, ctx, items }) => {
  const visible = items || section.items;
  if (!visible || visible.length === 0) return null;

  const configured = visible.filter((it) => it.isConfigured(ctx)).length;
  const total = visible.length;

  return (
    <div className="deal-terms-section">
      <div className="deal-terms-section__header">
        <span className="deal-terms-section__icon" aria-hidden="true">
          <i className={section.icon} />
        </span>
        <span className="deal-terms-section__title">{section.title}</span>
        <span className="deal-terms-section__count">{configured}/{total}</span>
      </div>

      <div className="deal-terms-section__items">
        {visible.map((it) => (
          <V3DealTermsItem key={it.key} item={it} ctx={ctx} />
        ))}
      </div>
    </div>
  );
};

V3DealTermsSection.propTypes = {
  section: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
  }).isRequired,
  ctx: PropTypes.object.isRequired,
  // Optional override — when provided, render exactly these items (used by
  // search filtering). Defaults to section.items.
  items: PropTypes.array,
};

V3DealTermsSection.defaultProps = {
  items: null,
};

export default V3DealTermsSection;
